export default "__VITE_ASSET__BV6WR08d__"